import React from 'react';
import PropTypes from 'prop-types';

import { t } from '../../services/i18nService';
import styles from './tableOfContents.scss';
import questionSelectionService from '../../services/QuestionSelectionService';
import settingsReader from '../../store/readHelpers/SettingsReader';
import tocActions from '../../actions/TocActions';
import Filter from './TOCFilterItem';

const { filterTypes } = tocActions;

class TOCFilters extends React.PureComponent {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        settings: PropTypes.object,
    };

    render() {
        const { settings, dispatch } = this.props;
        const questionSelectionEnabled = questionSelectionService.atLeastOneSectionWithQuestionSelectionEnabled();
        const flaggingEnabled = settingsReader.isFlaggingEnabled(settings);

        return (
            <div className={styles.filters}>
                <h3 className="sr-only">{t('testOverview.filterQuestionsHeader')}</h3>
                <div className="overview-filters" role="tablist">
                    <Filter filterName={filterTypes.ALL} dispatch={dispatch} />
                    {!questionSelectionEnabled ?
                        <Filter filterName={filterTypes.NOT_ATTEMPTED} dispatch={dispatch} />
                        :
                        null
                    }
                    {questionSelectionEnabled ?
                        <Filter filterName={filterTypes.MANUALLY_SELECTED} dispatch={dispatch} />
                        :
                        null
                    }
                    {questionSelectionEnabled ?
                        <Filter filterName={filterTypes.MANUALLY_SELECTED_NOT_ATTEMPTED} dispatch={dispatch} />
                        :
                        null
                    }
                    {flaggingEnabled && !questionSelectionEnabled ?
                        <Filter filterName={filterTypes.FLAGGED} dispatch={dispatch} />
                        : null
                    }
                </div>
            </div>
        );
    }
}

export default TOCFilters;
